import {
  Box,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { BakeasyButton } from '../../components/buttons/BakeasyButton';
import BakeasyLabelText from '../../components/lables/BakeasyLabelText';
import { AppContext } from '../../context/AppContext';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
import { createSupplierNote, ordersState } from '../../redux_store/slices/ordersSlice';
import { formatDateTime } from '../../utils/DateUtils';
import { invoiceState } from '../../redux_store/slices/invoiceSlice';
import { t } from 'i18next';
import { Close } from '@mui/icons-material';
import * as TextField from '../../components/textfields/BakeasyTextFields';
import { shippingsState } from '../../redux_store/slices/shippingsSlice';

interface SupplierNotesHistoryProps {
  from: string;
  fetchMethod: (payload: any) => any;
}

export const SupplierNotesHistory: React.FC<SupplierNotesHistoryProps> = ({
  from,
  fetchMethod
}) => {
  let myContext = React.useContext(AppContext);
  const dispatch = useAppDispatch();

  const { selectedValue }: any = useAppSelector(
    from === 'orderDetails'
      ? ordersState
      : from === 'invoiceDetails'
      ? invoiceState
      : from === 'shippingDetails'
      ? shippingsState
      : () => ({ selectedValue: null })
  );

  const [note, setNote] = useState<string>('');
  const [data, setData] = useState([]);

  function handleClose() {
    myContext.setDialog({ open: false });
  }

  async function handleSave() {
    try {
      const payload = { id: selectedValue?._id, note: note };
      await dispatch(createSupplierNote(payload));
      await dispatch(fetchMethod({ id: selectedValue?._id }));
      setNote('');
    } catch (error) {
      console.error('Failed to save', error);
    }
  }

  useEffect(() => {
    if (selectedValue && selectedValue.supplierNotes) {
      setData(selectedValue?.supplierNotes);
    }
  }, [selectedValue]);

  return (
    <>
      <DialogTitle
        sx={{ margin: 0, padding: 2 }}
        style={{ fontWeight: 600, fontSize: '1.2rem' }}
        minWidth={200}
      >
        <Grid container sx={{ flexDirection: 'row' }}>
          {t('SUPPLIER_NOTES')}
        </Grid>
      </DialogTitle>
      <IconButton
        onClick={handleClose}
        sx={{ position: 'absolute', right: 8, top: 8, color: theme => theme.palette.grey[500] }}
      >
        <Close />
      </IconButton>
      <Divider />
      <DialogContent sx={{ margin: 0 }}>
        {data?.map((item: any, index: number) => (
          <Grid key={index} sx={{ marginBottom: '15px' }}>
            <BakeasyLabelText label={formatDateTime(item.date)} value={item.notes} />
          </Grid>
        ))}
      </DialogContent>
      <Divider />
      <DialogActions sx={{ margin: 1 }}>
        <Box sx={{ flex: 1 }}>
          <TextField.Description
            label={t('NOTE')}
            rows={2}
            value={note}
            onChange={(event: any) => setNote(event.target.value)}
            fullWidth
          />
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <BakeasyButton
            fullWidth={false}
            size="small"
            variant="contained"
            onClick={handleSave}
            label={t('SAVE')}
          />
        </Box>
      </DialogActions>
    </>
  );
};
